import { CompanyContract } from '@terra/shared-contracts-company';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const companyClient = createTerraOrpcClient({
  contract: CompanyContract,
  serviceName: SERVICE_NAME,
});
